import { autorun, observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import "./MainArea.css";
import MainAreaAccordion from "./MainAreaAccordion";
import ModuleImageRendering from "./ModuleImageRendering";
import productPlaceholder from "../Images/placeholder_config_image.png";

type Props = {};

type State = {};

@observer
class MainArea extends React.Component<Props, State> {
	@observable renderImages: Array<string>;

	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly

		this.renderImages = [];

		autorun(() => {
			this.renderImages = store.productConfigurationStore?.getRenderImages || [];
		});
	}

	render() {
		const product = store.productConfigurationStore?.product;
		const imageUrl = product?.productBase?.image?.url ? product?.productBase?.image?.url : productPlaceholder;
		return (
			<div className="main-area">
				<MainAreaAccordion headline={store.configs?.generalPreviewText}>
					<div className="config-preview-wrapper">
						<img className="product-image" src={imageUrl} alt={product?.title?.rendered} />
						{this.renderImages &&
							this.renderImages.map((imageUrl: string, i) => {
								return <ModuleImageRendering imageUrl={imageUrl} key={`${i}-renderImage`}></ModuleImageRendering>;
							})}
					</div>
				</MainAreaAccordion>
			</div>
		);
	}
}

export default MainArea;
